export const ORG_MASTERS = "/org-structure/masters";
export const ORG_MASTER = (id) => `/org-structure/masters/${id}`;
export const ORG_TREE = "/org-structure/tree";
export const ORG_HEADS = "/org-structure/heads";
export const ORG_HEAD_STATUS = (headId) => `/org-structure/heads/${headId}/status`;
export const ORG_HEAD_CHILDREN = (headId) => `/org-structure/heads/${headId}/children`;
export const ORG_SUBTREE_USERS = "/org-structure/subtree-users";
export const ORG_LOCATION_DISTRICTS = "/org-structure/location-districts";
export const ORG_DESIGNATIONS = "/org-structure/designations";
export const ORG_NODES = "/org-structure/nodes";
export const ORG_NODE = (id) => `/org-structure/nodes/${id}`;
export const ORG_NODE_USERS = (nodeId) => `/org-structure/nodes/${nodeId}/users`;
export const ORG_NODE_USER = (mappingId) => `/org-structure/node-users/${mappingId}`;
